// A Wi-Fi password in a details sheet — masked until the eye is pressed, so it
// is not read off the screen over someone's shoulder. Used by the phone's
// Device Details and the desktop's Device Info (core/devices/deviceWifi decides
// who gets a password at all).

import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export default function WifiPasswordValue({ value, color, weight = 600 }) {
  const [shown, setShown] = useState(false);
  if (!value) return <Typography sx={{ color, fontWeight: weight }}>—</Typography>;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
      <Typography sx={{ color, fontWeight: weight, wordBreak: 'break-all', userSelect: shown ? 'text' : 'none' }}>
        {shown ? value : '•'.repeat(Math.min(12, Math.max(8, value.length)))}
      </Typography>
      <IconButton
        size="small"
        aria-label={shown ? 'Hide password' : 'Show password'}
        onClick={() => setShown((s) => !s)}
        sx={{ color }}
      >
        {shown ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
      </IconButton>
    </Box>
  );
}
